import moment from 'moment-timezone'

export default {
    format: function(date) {
        return moment(date).tz('Europe/Rome').format('DD/MM/YYYY HH:mm')
    },
    formatDate: function(date) {
        return moment(date).tz('Europe/Rome').format('DD/MM/YYYY')
    },
    formatTime: function(date) {
        return moment(date).tz('Europe/Rome').format('HH:mm')
    },
    formatWithSeconds: function(date) {
        return moment(date).tz('Europe/Rome').format('DD/MM/YYYY HH:mm:ss')
    }
}